import { apiAgents } from "../../axios/apiAgentsInstance";


export const changeAgentStatus = async ({ agentId, status, token }) =>{
	if (!agentId) throw new Error('agentId is required');
	if (!status) throw new Error('status is required');
	if (!token) throw new Error('token is required');

	try {
		const { data } = await apiAgents.patch(`/${agentId}/status`,
			{ agent_disponibility: status },
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return data;
	} catch (error) {
		console.error('Error changing agent status:', error);
		throw error;
	}
};

export const updateAgentInformation = async ({ id_agent, token, payload }) => {
	if (!id_agent) throw new Error('id_agent is required');
	if (!token) throw new Error('token is required');
	if (!payload) throw new Error('payload is required');

	try {
		const { data } = await apiAgents.patch(
			`/${id_agent}`,
			payload,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return data;
	} catch (error) {
		console.error('Error updating agent information:', error);
		throw error;
	}
};

export const resetAgentPassword = async ({ id_agent, token} ) => {
	if (!id_agent) throw new Error('id_agent is required');
	if (!token) throw new Error('token is required');

	try {
		const { data } = await apiAgents.patch(
			`/${id_agent}/reset-password`,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			}
		);

		return data;
	} catch (error) {
		console.error('Error resetting agent password:', error);
		throw error;
	}
};